import {React, useState} from 'react'

import styled from 'styled-components';
import { HiMiniSquares2X2 } from "react-icons/hi2";
import { FaCircle, FaExternalLinkAlt } from "react-icons/fa";

function MapFilter({
  cleanFilter,
  setFilter,
  exportEnabled,
  exportFunction
}) {
    const [filterSelected, setFilterSelected] = useState('Todos');
    const changeFilter = (value, id) =>{
        setFilterSelected(value);
        if(setFilter) setFilter(id);
    }
  return (
    <Container>
        <div className="filters">
          {filterArray.map(({icon, label, background, id}, index)=> (
            <FilterButton 
              key={label}
              onClick={() => filterSelected===label ? '' :changeFilter(label, id)} 
              $background={background}
              $isActive={filterSelected===label ? true : false}>
                <div className='pagesIcon'>{icon}</div>
                <span>{label}</span>
                
            </FilterButton>
          ))}
        </div>
        <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
          {exportEnabled ? <button className='export-button' onClick={exportFunction}> <FaExternalLinkAlt />Exportar datos</button> : ''}
          {cleanFilter ? <button className='clean-filter' onClick={() => filterSelected==='Todos' ? '' :changeFilter('Todos')}>Limpiar búsqueda</button> : ''}
        </div>
    </Container>
  )
}

//#region filterArray
const filterArray = [
    {
        label: "Todos",
        id: "all",
        icon: <HiMiniSquares2X2/>,
        background: "rgb(52, 199, 89)"     
    },
    {
        label: "Activos",
        id: "actives",
        icon: <FaCircle/>,
        background: "rgb(52, 199, 89)"        
    },
    {
        label: "Alerta",
        id: "alerts",
        icon: <FaCircle/>,
        background: "rgb(251, 188, 4)"  
    },
    {
        label: "Inactivos",
        id: "inactives",
        icon: <FaCircle/>,
        background: "rgba(255, 58, 48, 0.843)"
    }
]
//#endregion

//#region styles
const Container = styled.div`

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    width: 100%;

    .filters{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      background: ${(props)=> props.theme.bg};
      box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
      min-width: 350px;
      width: 40%;
      min-height: 33px;
      height: 3.5vh;
      border-radius: 5px;
    }

    .clean-filter {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 8.5rem;
      height: 2rem;
      color: #fff;
      background-color: #34C759;
      border: none;
      border-radius: 8px;
      transition: background-color 0.3s ease;
      cursor: pointer;      
    }

    .export-button{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      width: 8.5rem;
      height: 2rem;
      color: #34C759;
      background-color: trasparent;
      border: solid 1px #34C759;
      border-radius: 8px;
      transition: background-color 0.3s ease;
      cursor: pointer;
    }

    .export-button:hover{
      color: #fff;
      background-color: #34C759;
    }

    .clean-filter:hover{
      background-color: #28A745;      
    }
`;

const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  height: 75%;
  padding: 0 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  background: ${(props)=>props.$isActive ? props.$background : props.theme.bg};
  color: ${(props)=>props.$isActive ? props.theme.bgtotal : props.theme.text};

  transition: all 0.3s;

  svg {
    display: block;
    color: ${(props)=>props.$isActive ? props.theme.bg : props.$background};
  }
`;
//#endregion

export default MapFilter